import { cn } from '@utils/helpers';
import { useFragment } from 'react-relay';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { simpleLinkFragment } from './SimpleLink.relay';

import type { SimpleLinkPropsType } from './types';

const SimpleLink: React.FC<SimpleLinkPropsType> = (props: SimpleLinkPropsType) => {
  const location = useLocation();
  const simpleLink = useFragment(simpleLinkFragment, props.simpleLink);

  const link = !simpleLink.url.match(/^https?:\/\/|\/assets\//) ? (
    <RouterLink className="simple-link font-body text-xs" to={simpleLink.url}>
      {simpleLink.label}
    </RouterLink>
  ) : (
    <a href={simpleLink.url} target="_blank" rel="noreferrer">
      {simpleLink.label}
    </a>
  );

  if (props.dropWrapper) {
    return link;
  }

  return (
    <button type="button" className={cn('[&.active_a]:text-active font-body font-bold text-xs uppercase', { active: location.pathname === simpleLink.url })} onClick={props.onClick}>
      {link}
    </button>
  );
};

export { SimpleLink };
